/** The preset counts offered under the import count field. */
const PRESETS = [1, 10, 25, 50, 100, 250, 500, 1000, 2000, 2500] as const;

/** Presets up to `max`, ending with `max` itself so the full count is one click. */
export function importCountPresets(max: number): number[] {
  const presets: number[] = PRESETS.filter((count) => count < max);
  if (max >= 1) presets.push(max);
  return presets;
}

/** Digits typed into the field, clamped to 1..max. Null when nothing usable. */
export function parseImportCount(raw: string, max: number): number | null {
  const digits = raw.replace(/\D/g, '');
  if (!digits) return null;
  const count = Number(digits);
  if (!Number.isFinite(count) || count < 1) return null;
  return Math.min(count, max);
}
